
const Title = () => {
    return (
        <a href="/" className="titile">
            BookUsNow
        </a>
    )
}

export default Title;